import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from './base.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LoginModule } from '../login/login.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [BaseComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    LoginModule,
    ReactiveFormsModule,
  ]
})
export class BaseModule { }
